<template>
  <div>
    <h3 class="my-auto">
      <b-button @click.prevent="backtolist" variant="outline-primary">&lt; Return to list</b-button>
      <span v-if="partner_id > 0" class="ml-4">{{partner_name}}</span>
      <span v-if="partner_id < 0" class="ml-4">Add Partner</span>
    </h3>
    <b-tabs class="col-12 px-0 mx-0 mt-2" content-class="mt-3">
      <b-tab class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="col-12 text-center">
            General Information
          </div>
        </template>
        <b-card no-body class="border-0 mx-0 px-0 pl-0 pr-0 col-12">
          <b-row>
          <!-- div class="col-5 form-inline" -->
          <div class="col-8">
          <!-- form class="form-inline" autocomplete=off @submit.stop.prevent-->
          <form autocomplete=off @submit.stop.prevent>
            <b-form-group 
              label-cols="4"
              label="Partner name"
              class="col-12"
              invalid-feedback="Partner name cannot be blank"
            >
              <b-form-input  
                id="partner_name" 
                :state="partner_name_valid"
                class="form-control col-7"
                v-model="partner_name"
                v-on:change="savefield('g_partners',partner_id,'partner_name',partner_name)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group 
              label-cols="4"
              label="Partner address"
              class="col-12"
              invalid-feedback="Partner address cannot be blank"
            >
              <b-form-input  
                id="partner_address_1" 
                :state="partner_address_valid"
                class="form-control col-7"
                v-model="partner_address_1"
                v-on:change="savefield('g_partners',partner_id,'partner_address_1',partner_address_1)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group 
              label-cols="4"
              label=""
              class="col-12"
              invalid-feedback="Partner address cannot be blank"
            >
              <b-form-input  
                id="partner_address_2" 
                :state="partner_address_valid"
                class="form-control col-7"
                v-model="partner_address_2"
                v-on:change="savefield('g_partners',partner_id,'partner_address_2',partner_address_2)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group 
              label-cols="4"
              label="Zip code"
              class="col-12"
              invalid-feedback="Partner address cannot be blank"
            >
              <b-form-input  
                id="partner_zip_code" 
                :state="partner_address_valid"
                class="form-control col-7"
                v-model="partner_zip_code"
                v-on:change="savefield('g_partners',partner_id,'partner_zip_code',partner_zip_code)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group 
              label-cols="4"
              label="City"
              class="col-12"
              invalid-feedback="Partner address cannot be blank"
            >
              <b-form-input  
                id="partner_city" 
                :state="partner_address_valid"
                class="form-control col-7"
                v-model="partner_city"
                v-on:change="savefield('g_partners',partner_id,'partner_city',partner_city)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group 
              label-cols="4"
              label="Country"
              class="col-12"
              invalid-feedback="You must select a country"
            >
              <b-form-select  
                id="partner_country_id" 
                :state="partner_country_id_valid"
                class="form-control col-7"
                v-model="partner_country_id"
                :options="countries"
                v-on:change="savefield('g_partners',partner_id,'partner_country_id',partner_country_id)" 
                autocomplete="off"
              >
              </b-form-select>
            </b-form-group>

            <b-form-group 
              label-cols="4"
              label="Partner registration number"
              class="col-12"
              invalid-feedback="Partner registration number cannot be blank"
            >
              <b-form-input  
                id="partner_registration_number" 
                :state="partner_address_valid"
                class="form-control col-7"
                v-model="partner_registration_number"
                v-on:change="savefield('g_partners',partner_id,'partner_registration_number',partner_registration_number)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group 
              label-cols="4"
              label="Partner e-mail"
              class="col-12"
              invalid-feedback="Partner e-mail cannot be blank"
            >
              <b-form-input  
                id="partner_email" 
                :state="partner_address_valid"
                :class="`form-control col-7  ${anon ? 'g-anon' : '' }`"
                v-model="partner_email"
                v-on:change="savefield('g_partners',partner_id,'partner_email',partner_email)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
            <div class="form-group col-12 mt-4">
              <b-button 
                v-if="partner_id < 1" 
                @click.prevent="partner_create" 
                class="mt-10"
                variant="primary"
              >
                Save New Partner
              </b-button>
            </div>
          </form>
          </div>
          <div class="col-6">
            <div v-if="partner_id > 0" class="form-inline form-group col-12">
              <span class="col-12 px-0 mx-0 pt-2 pb-4">Labels</span><br>
                <span v-bind:key="label.id" v-for="label in labels" :style="{ 'background': '#'+label.color}" class="mr-2 py-1 pl-2 pr-2 rounded">
                  {{ label.label }}
                  <span 
                    @click.stop.prevent="removelabel(label.id)"
                  >
                    <fa-icon name="trash-alt" />
                  </span>
                </span>
                <span 
                  v-show="addinglabel==0"
                  class="icon-plus pt-0 text-primary"
                  :class="labels.length==0?'pt-2':'pt-0'"
                  @click.stop.prevent="addlabel(partner_id)"
                >
            </span>
            <b-input-group 
            v-show="addinglabel==partner_id"
              small class="col-3 pl-0 ml-0 py-0 my-0">
              <b-form-input
                small
                class="form-control-sm py-0"
                v-model="addinglabeltext"
                placeholder="Add label"
                type="text"
                @keyup.enter.prevent="saveaddlabel"
                @keyup.escape.prevent="addinglabel = 0"
                autocomplete="off"
                ref="addinglabel"
              >
              </b-form-input>
              <b-input-group-text class="py-0" slot="append">
                <b-btn
                  variant="link"
                  size="sm"
                  @click="addinglabel = 0"
                  class="p-0 i"
                >
                X
                </b-btn>
              </b-input-group-text>
            </b-input-group>
            </div>
          </div>
          </b-row>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>

export default {
  components: {
  },
  name: 'Consultant',
  created() {
    this.countries_get();
    this.partner_get();
  },
  data: function() {
    return {
      partner_name: '',
      partner_name_valid: null,
      partner_address_1: '',
      partner_address_valid: null,
      partner_address_2: '',
      partner_zip_code: '',
      partner_zip_code_valid: null,
      partner_city: '',
      partner_city_valid: null,
      partner_registration_number: '',
      partner_registration_number_valid: null,
      partner_country_id: 0,
      partner_country_id_valid: null,
      partner_email: '',
      partner_email_valid: null,
      countries: [],
      labels: [],
      addinglabel: 0,
      addinglabeltext: '',
      loading: true,
    }
  },
  computed: {
    anon: function() {
      return this.$store.state.anon;
    },
    partner_id: {
      get() {
        return this.$store.state.currentpartner_id;
      }
    },
    emailinvalidfeedback() {
      if (this.email == '') { return "E-mail is invalid"; }
      // eslint-disable-next-line
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email) == false) {
        return "Incorrect e-mail format";
      }
      return "E-mail already exists";
    }
  },
  watch: {
    partner_id: function() {
      this.partner_get()
    }
  },
  methods: {
    checkform() {
      var formok = true;
      this.partner_name_valid = true;
      if (this.partner_name == '') { 
        this.partner_name_valid = false; 
        formok = false;
      }
      return formok;
    },
    partner_create() {
      if (this.checkform()) {
        var partner = {
          partner_name: this.partner_name,
          partner_address_1: this.partner_address_1,
          partner_address_2: this.partner_address_2,
          partner_zip_code: this.partner_zip_code,
          partner_city: this.partner_city,
          partner_country_id: this.partner_country_id,
          partner_registration_number: this.partner_registration_number,
          partner_email: this.partner_email,
        }
        this.$store.dispatch('partner_create', { partner: partner })
        .then((resp) => {
          var partner_id = resp.data.id;
          this.$store.dispatch('partner_setcurrent',{ partner_id: partner_id })
          .then(() => {
            this.partner_get();
          });
        });
      }
    },
    savefield(tablename,id,fieldname,value) {
      if ( id > 0 ) {
        if (this.checkform()) {
          var record = {
            id: id,
            [fieldname]: value,
          }
          this.$store.dispatch('field_save', { tablename: tablename,record: record })
          .then(() => {
            this.$store.dispatch('partnerchanged_set',{ partner_id: this.partner_id });
          });
        }
      }
    },
    partner_get() {
      this.partner_name = '';
      this.labels = [];
      if (this.partner_id > 0) {
        this.$store.dispatch('partner_fetch', { partner_id: this.partner_id })
        .then((resp) => {
          this.partner_name = resp.data.partner_name;
          this.partner_address_1 = resp.data.partner_address_1;
          this.partner_address_2 = resp.data.partner_address_2;
          this.partner_zip_code = resp.data.partner_zip_code;
          this.partner_city = resp.data.partner_city;
          this.partner_country_id = resp.data.partner_country_id;
          this.partner_registration_number = resp.data.partner_registration_number;
          this.partner_email = resp.data.partner_email;
          this.labels = resp.data.labels;
          this.loading = false;
        });
      }
    },
    backtolist() {
      this.$store.dispatch('partner_setcurrent',{ partner_id: 0 })
    },
    conslabels_get() {
      this.$store.dispatch('partner_fetch', { partner_id: this.partner_id })
      .then((resp) => {
        this.labels = resp.data.labels;
      });
    },
    saveaddlabel() {
      if (this.addinglabeltext != '') {
        var savelabel = {
          partner_id: this.addinglabel,
          label: this.addinglabeltext,
        }
        this.$store.dispatch('partnerlabel_add', { label: savelabel })
        .then(()=> {
          this.conslabels_get();
          this.$store.dispatch('partnerlabelchanged_set', { partner_id: this.partner_id });
        });
      }
      this.addinglabel = 0;
      this.addinglabeltext = '';
    },
    addlabel(id) {
      this.addinglabel = id;
      this.addinglabeltext = '';
      this.$nextTick(() => this.$refs.addinglabel.focus())
    },
    removelabel(partnerlabel_id) {
      this.$store.dispatch('partnerlabel_delete', { id: partnerlabel_id })
      .then(()=> {
        this.conslabels_get();
        this.$store.dispatch('partnerlabelchanged_set', { partner_id: this.partner_id });
      });
    },
    countries_get() {
      this.$store.dispatch('countries_fetch')
      .then((resp) => {
        this.countries = [];
        for (var i=0;i<resp.data.result.length;i++) {
          var countryoption = {
            value: resp.data.result[i].id,
            text: resp.data.result[i].country_name,
          }
          this.countries.push(countryoption);
        }
      });
    },
  }
}
</script>
